export default __webpack_public_path__ + "static/media/img6.99e0c3b1.jpg";